import { isEqual } from "lodash";
import { Stage } from "react-migration/domains/sites/typings/Stage";
import { sitesPipelineStore } from "../store";

export const handleStagesUpdateFromVue = (stages: Stage[]) => {
  const orderedStageIds = stages.map(({ _id }) => _id);
  const hasReordered = !isEqual(orderedStageIds, sitesPipelineStore.orderedStageIds);

  if (hasReordered) {
    sitesPipelineStore.orderedStageIds = orderedStageIds;
  }

  stages.forEach((stage) => {
    const savedStage = sitesPipelineStore.stageByStageId[stage._id];
    if (!isEqual(stage, savedStage)) {
      sitesPipelineStore.stageByStageId[stage._id] = stage;
    }
  });

  sitesPipelineStore.vueStages = stages;
};
